import { Dropdown, Avatar, Menu } from 'antd';
import React from 'react';
import { useHistory } from 'react-router-dom';
import BuglyIconBlue from '@/assets/images/public/bugly2.0.react.svg?react';
import { userImplement } from '@/config/hooks/user';
import { isInternal } from '@/infrastructure/auth';
import style from './index.module.scss';


export const Header = () => {
  const history = useHistory();
  const handleSelect = (key: string) => {
    if (key === 'myAppList') {
      history.push('/workbench/apps');
    }
    if (key === 'profile') {
      history.push('/user/profile');
    }
    if (key === 'logout') {
      userImplement.logout();
    }
  };

  const renderMenu = () => (
    <Menu onClick={({ key }) => handleSelect(key)}>
      <Menu.Item key="myAppList" style={{ fontSize: '16px' }}>
        我的产品
      </Menu.Item>
      {isInternal() && <Menu.Item key="profile" style={{ fontSize: '16px' }}>
        个人信息
      </Menu.Item>}
      <Menu.Item key="logout" style={{ fontSize: '16px' }}>
        退出登录
      </Menu.Item>
    </Menu>
  );

  return (
    <div className={style.header}>
      <BuglyIconBlue />
      <ul className={style.topMenu}>
        <li><a onClick={() => history.push('/index/main')}>首页</a></li>
        <li><a onClick={() => history.push('/workbench/apps')}>产品与服务</a></li>
        <li><a href="https://iwiki.woa.com/pages/viewpage.action?pageId=673052817" target="_blank">SDK</a></li>
        <li><a href="https://docs.bugly.woa.com" target="_blank">文档中心</a></li>
        {!isInternal() && <li><a href="https://mk.woa.com/coterie/505" target="_blank">论坛</a></li>}
        <li><a href="https://iwiki.woa.com/pages/viewpage.action?pageId=673052838" target="_blank">常见问题</a></li>
        <li>
          <Dropdown overlay={renderMenu} arrow placement={'bottomRight'}>
            <Avatar size={28} src={userImplement.getAvatar()} />
          </Dropdown>
        </li>
      </ul>
    </div>
  );
};
